import {createReducer, on} from '@ngrx/store';
import {
  BelegAktualisierungenState,
  initialBelegAktualisierungenState,
} from '../states/beleg-aktualisierungen.state';
import {BelegAktualisierungenActions} from '../actions/beleg-aktualisierungen.actions';


export const belegAktualisierungenReducer = createReducer(
  initialBelegAktualisierungenState,

  on(
    BelegAktualisierungenActions.loadBelegAktualisierungenSuccess,
    (state, {belegId, aktualisierungen}): BelegAktualisierungenState => ({
      ...state,
      byBelegId: {
        ...state.byBelegId,
        [belegId]: aktualisierungen,
      },
    }),
  ),

  // INFO: Beim Fehlschlag den letzten Stand verwerfen — ein veralteter Hinweis ist irrefuehrender
  //       als kein Hinweis.
  on(
    BelegAktualisierungenActions.loadBelegAktualisierungenFailure,
    (state, {belegId}): BelegAktualisierungenState => {
      const {[belegId]: _entfernt, ...rest} = state.byBelegId;
      return {
        ...state,
        byBelegId: rest,
      };
    },
  ),
);
